import {
    DAY_COLUMN_KEY,
    MONTH_COLUMN_KEY,
    QUARTER_COLUMN_KEY,
    YEARLY_COMPARISON_KEYS,
} from 'business/constants';
import { TimeScales as TS } from 'business/definitions';
import { isDate } from 'helpers/helpers';

export type YearlyComparisonScale =
    | typeof MONTH_COLUMN_KEY
    | typeof DAY_COLUMN_KEY
    | typeof QUARTER_COLUMN_KEY;

const timeScaleToColumnKey: Record<string, YearlyComparisonScale | undefined> =
    {
        [TS.month]: MONTH_COLUMN_KEY,
        [TS.day]: DAY_COLUMN_KEY,
        [TS.quarter]: QUARTER_COLUMN_KEY,
    };

export const isYearlyComparisonScale = (
    scale: string,
): scale is YearlyComparisonScale => YEARLY_COMPARISON_KEYS.includes(scale);

export const getYearlyComparisonScale = (columns: ResponseColumnT[]) => {
    const dateColumn = columns.find(
        (col) =>
            isDate(col.type) &&
            col.scale &&
            [TS.month, TS.day, TS.quarter].includes(col.scale),
    );
    const scale = dateColumn?.scale;
    return scale ? timeScaleToColumnKey[scale] : undefined;
};

export const getYearlyComparisonCategoryScale = (
    columns: ResponseColumnT[],
) => {
    const categoryColumn = columns.find(
        (col) =>
            col.type === 'category' &&
            col.key &&
            YEARLY_COMPARISON_KEYS.includes(col.key),
    );
    return categoryColumn?.key;
};
